module Widgets.FormPreview where

import Common

import API.Document (Document)
import Concur.React.DOM as D
import Concur.React.Props as P

type PreviewState =
    { loaded :: Boolean
    -- ^ Whether we've loaded the preview yet. If this is true, we'll continue
    -- to render the iframe even when the details element is closed.
    , doc :: Document
    }

docPdfUrl :: Document -> Maybe String
docPdfUrl doc = _.url <$> find (\r -> r.format == "PDF") doc.exports

-- | Create a preview widget for a given document.
initDocPreview :: Document -> PreviewState
initDocPreview doc = { loaded: false, doc }

renderPreview :: PreviewState -> Widget HTML PreviewState
-- If not loaded, we just show an empty closed details, and then switch to the
-- loaded state after.
renderPreview s@{ loaded: false } = do
    _ <- D.details
        [ P.onToggle, P.open false, P.className "form-submission-preview" ]
        [ D.summary'
            [ D.h1
                [ P.className "preview-heading" ]
                [ D.text $ lookupTranslation "preview" ]
            ]
        ]
    pure $ s { loaded = true }
renderPreview s = do
    -- Once loaded, we just keep the iframe inside the details even when
    -- closed. At this point, this will never return.
    D.details
        [ P.open false, P.className "form-submission-preview" ]
        [ D.summary'
            [ D.h1
                [ P.className "preview-heading" ]
                [ D.text $ lookupTranslation "preview" ]
            ]
        , previewIFrame s
        ]


previewIFrame :: forall a. PreviewState -> Widget HTML a
previewIFrame state = case docPdfUrl state.doc of
    Just url -> D.div' [ D.iframe [ P.src $ url ] [] ]
    Nothing -> D.div' [ D.text $ lookupTranslation "no-pdf" ]
